import { useField } from "formik";

import {
  PhoneNumber,
  PhoneNumberInput,
  PhoneNumberInputProps,
} from "./PhoneNumberInput";
import {
  InputWrapper,
  InputWrapperProps,
} from "../_assets/input-wrapper/InputWrapper";

interface Props
  extends Omit<PhoneNumberInputProps, "onChange">,
    InputWrapperProps {
  name: string;
  info?: React.ReactNode;
  testID?: string;
}

export function PhoneNumberInputField({
  name,
  span = "auto",
  testID = "phone-number-input-field",
  ...props
}: Props) {
  const [field, meta, helpers] = useField(name);

  return (
    <InputWrapper span={span}>
      <PhoneNumberInput
        validationState={meta.touched && meta.error ? "invalid" : "valid"}
        errorMessage={meta.touched && parseErrorMessage(meta.error)}
        {...field}
        {...props}
        onChange={helpers.setValue}
        testID={testID}
      />
    </InputWrapper>
  );
}

const parseErrorMessage = (error?: string | Partial<PhoneNumber>) => {
  if (!error) {
    return null;
  }

  if (typeof error === "string") {
    return error;
  }

  if (Array.isArray(error) && error.every((e) => typeof e === "string")) {
    return error.join(", ");
  }

  if (error.country) {
    return error.country;
  }

  if (error.number) {
    return error.number;
  }

  if (error.national_number) {
    return error.national_number;
  }

  return "Unknown error, try again later";
};
